import React from 'react';

import { getHours } from 'lib/helpers/utility';

import Select from 'components/shared/Select/Select';

import { formatTimeLabel } from './utils';

const hoursOptions = getHours();

const TimeRangeSelector = ({ label, startValue, endValue, onStartChange, onEndChange }) => (
  <div className="flex flex-wrap items-end gap-3">
    <Select
      label={label}
      options={hoursOptions}
      isClearable={false}
      placeholder="Select starting time"
      value={startValue != null ? { label: formatTimeLabel(startValue), value: startValue } : null}
      onChange={(option) => onStartChange(option?.value)}
      parentClassName="flex-1"
    />
    <span className="mb-3 text-sm text-neutral-800">to</span>
    <Select
      options={hoursOptions}
      isClearable={false}
      placeholder="Select ending time"
      value={endValue != null ? { label: formatTimeLabel(endValue), value: endValue } : null}
      onChange={(option) => onEndChange(option?.value)}
      parentClassName="flex-1"
    />
  </div>
);

export default TimeRangeSelector;
